<template>
	<vs-prompt
        class="image-popup"
		:active.sync="activePrompt"
		:buttons-hidden="true"
		button-cancel="filled"
        fullscreen
        title=""
		@keydown.esc="closePopup"
        @close="fileName = null"
	>
		<div class="flex justify-center align-center">
			<img class="prompt__image" :src="fileName" alt="">
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ImagePopup",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		file: {
			type: [Object, String],
            default: () => ({})
		}
	},
	created() {
		document.addEventListener('keyup', this.closePopup);
	},
	destroyed() {
		document.removeEventListener('keyup', this.closePopup);
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		},
        fileName: {
            get() {
				const img = this.file
				if (!img) return
				if (img.url) {
          return img.url
        }
				if (img.fullUrl) {
          return img.fullUrl
        }
				if (img.message.split('href=')[1]) {
          const href = img.message.split('href=')[1].split('"')
          return href[1] ? href[1] : ''
        }
				if (img.message) {
          return img.message
        }
        return ''
			},
			set(value) {
				this.$emit("update:file", value);
			}
        },
	},
    methods: {
		closePopup(e) {
			if (e.keyCode === 27) {
				this.activePrompt = false
			}
		}
    }
};
</script>
<style lang="scss">
.image-popup {
    z-index: 999999 !important;
	.vs-dialog {
		max-width: 100% !important;
        width: fit-content !important;
	}
}
.prompt__image {
    object-fit: contain;
    max-width: 100%;
    max-height: 90vh;
}
</style>